//
import { Divider, Stack } from '@mui/material';
import { Label } from '@/components';
import {
  VBMAdditionalServices,
  VBMCardTitle,
  VBMCardWrapper,
  VBMCleaningExtras,
  VBMExtraHours,
  VBMLinenAmenities,
  VBMPets,
} from '..';
// redux
import { useSelector } from '@/stores';
// hooks
import useResponsive from '@/hooks/useResponsive';
// type
import { BookingSession } from '@/features/bookings-management/types';
type VBMCleaningTypeAndExtrasProps = {
  editable?: boolean;
  bookingSession?: BookingSession;
  sessionView?: boolean;
};

export default function VBMCleaningTypeAndExtras({
  editable,
  bookingSession,
  sessionView = false,
}: VBMCleaningTypeAndExtrasProps) {
  const booking = useSelector((state) => state.booking);
  const downMd = useResponsive('down', 'md');
  return (
    <VBMCardWrapper>
      <Stack
        spacing={2}
        divider={<Divider orientation="horizontal" />}
        sx={{ pt: 1 }}
      >
        <Stack spacing={1}>
          <VBMCardTitle title="Cleaning Type" />
          <Label
            sx={{
              backgroundColor: 'primary.main',
              color: 'background.paper',
              fontSize: downMd ? 10 : 15,
              p: 1,
              width: 'fit-content',
            }}
          >
            {sessionView && bookingSession
              ? `${bookingSession.service_variant?.service.name} - ${bookingSession.service_variant?.name}`
              : `${booking.service_variant?.service.name} - ${booking.service_variant?.name}`}
          </Label>
        </Stack>
        {sessionView && (
          <VBMLinenAmenities
            editable={editable}
            bookingSession={bookingSession}
          />
        )}
        <VBMCleaningExtras
          editable={editable}
          bookingSession={bookingSession}
          sessionView={sessionView}
        />
        {sessionView && (
          <VBMAdditionalServices
            editable={editable}
            bookingSession={bookingSession}
            sessionView={sessionView}
          />
        )}
        <VBMExtraHours
          editable={editable}
          bookingSession={bookingSession}
          sessionView={sessionView}
        />
        <VBMPets
          editable={editable}
          bookingSession={bookingSession}
          sessionView={sessionView}
        />
      </Stack>
    </VBMCardWrapper>
  );
}
